import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  Button,
  Spinner,
  Row,
  Col,
  Input
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Questions = () => {

  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState({});
  const [timer, setTimer] = useState(0);
  const [domainName, setDomainName] = useState("");
  const [isCompleted, setIsCompleted] = useState(false); // ✅ NEW
  const [domainId, setDomainId] = useState(null);
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");

  const token = localStorage.getItem("token");



  /* ===============================
   CLEAN CONDITION (PUT HERE)
================================ */
  const isAudioDomain = Number(domainId) === 2;

  /* =================================
     FETCH QUESTIONS
  ================================= */

  useEffect(() => {

    axios.get(
      // "http://localhost/qads_interview/interview/question.php",
      "https://interview.qads.co.in/qads_interview/interview/question.php",
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(res => {

        console.log("FULL RESPONSE:", res.data);
        setQuestions(res.data.data.questions);
        setTimer(res.data.data.remaining_time_seconds);
        setDomainName(res.data.data.domain_name);

        setDomainId(res.data.data.domain_id);

        setUserName(res.data.data.user_name);
      })
      .catch(err => {
        toast.error(
          err.response?.data?.message || "Failed to load questions"
        );
      })
      .finally(() => setLoading(false));

  }, [token]);

  /* =================================
     TIMER COUNTDOWN
  ================================= */

  useEffect(() => {

    if (timer <= 0) return;

    const interval = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);

  }, [timer]);

  useEffect(() => {

    if (timer <= 0 && loading === false) {

      axios.post(
        // "http://localhost/qads_interview/interview/finish_interview.php",
        "https://interview.qads.co.in/qads_interview/interview/finish_interview.php",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      )
        .then(() => {

          toast.error("Time is up! Interview closed");

          setTimeout(() => {
            navigate("/result");
          }, 2000);

        })
        .catch(() => {
          navigate("/result");
        });

    }

  }, [timer, loading]);

  /* =================================
     ANSWER CHANGE
  ================================= */

  const handleAnswerChange = (questionId, value) => {
    setAnswers({
      ...answers,
      [questionId]: value
    });
  };

  /* =================================
     SUBMIT INTERVIEW
  ================================= */

  const handleSubmit = () => {

    const totalAnswered = Object.keys(answers).filter(
      key => answers[key] && answers[key].toString().trim() !== ""
    ).length;

    // If not all questions answered → Show popup
    if (totalAnswered < questions.length) {

      const confirmSubmit = window.confirm(
        "You have not answered all questions. Do you still want to submit the interview?"
      );

      if (!confirmSubmit) return;
    }

    /* ===============================
       SALES EXECUTIVE → AUDIO
    =============================== */

    if (isAudioDomain) {

      const formData = new FormData();

      questions.forEach(q => {
        if (answers[q.id]) {
          formData.append("question_id[]", q.id);
          formData.append("audio[]", answers[q.id]);
        }
      });

      axios.post(
        // "http://localhost/qads_interview/interview/submit_answer.php",
        "https://interview.qads.co.in/qads_interview/interview/submit_answer.php",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      )
        .then(res => {

          toast.success(res.data.message);

          setTimeout(() => {
            navigate("/result");
          }, 1500);

        })
        .catch(err => {
          toast.error(err.response?.data?.message);
        });

    }

    /* ===============================
       TEXT DOMAIN
    =============================== */

    else {

      const formattedAnswers = questions
        .filter(q => answers[q.id])
        .map(q => ({
          question_id: q.id,
          answer: answers[q.id]
        }));

      axios.post(
        // "http://localhost/qads_interview/interview/submit_answer.php",
        "https://interview.qads.co.in/qads_interview/interview/submit_answer.php",
        {
          answers: formattedAnswers
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => {

          toast.success("Submitted Successfully 🎉");

          setTimeout(() => {
            navigate("/result");
          }, 1500);

        })
        .catch(err => {
          toast.error(err.response?.data?.message);
        });

    }

  };

  /* =================================
     FORMAT TIME
  ================================= */

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  /* =================================
     IF COMPLETED → SHOW THANK YOU PAGE
  ================================= */

  if (isCompleted) {
    return (
      <div className="interview-wrapper">
        <Card className="interview-card text-center">
          <CardBody>
            <h2 className="completed-title">🎉 Interview Completed</h2>
            <p className="completed-text mt-3">
              Thank you for attending the interview.
            </p>
          </CardBody>
        </Card>
      </div>
    );
  }

  return (
    <Container className="mt-5">

      <ToastContainer position="top-right" />

      <Row className="mb-3">
        <Col className="text-end text-uppercase fw-bold">
          {userName} | {domainName}
        </Col>
      </Row>

      <h3 className="text-center mb-4 violet-text">
        Interview Questions
      </h3>

      <h5 className="text-center mb-4">
        Remaining Time : {formatTime(timer)}
      </h5>

      {loading ? (
        <div className="text-center">
          <Spinner />
        </div>
      ) : (

        <Row>
          {questions.map((q, index) => (

            <Col md="12" key={q.id} className="mb-4">

              <Card className="shadow-sm">
                <CardBody>

                  <CardTitle>
                    Q{index + 1}. {q.question}

                    {isAudioDomain && (
                      <div
                        style={{
                          fontSize: "14px",
                          marginTop: "6px",
                          fontWeight: "bold",
                          color: "#444"
                        }}
                      >
                        Record and upload the audio file
                      </div>
                    )}


                  </CardTitle>

                  {isAudioDomain ? (

                    <Input
                      type="file"
                      accept="audio/*"
                      onChange={(e) =>
                        handleAnswerChange(q.id, e.target.files[0])
                      }
                    />

                  ) : (

                    <Input
                      type="text"
                      placeholder="Type your answer"
                      value={answers[q.id] || ""}
                      onChange={(e) =>
                        handleAnswerChange(q.id, e.target.value)
                      }
                    />

                  )}

                </CardBody>
              </Card>

            </Col>
          ))}

          <Col md="12" className="text-center mt-3">
            <Button onClick={handleSubmit} className="submit-btn">
              Submit Interview
            </Button>
          </Col>

        </Row>

      )}

    </Container>
  );
};

export default Questions;